import { CciTab } from '@/features/leads/components/Detail/Tabs/CciTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/cci')({
  component: CciTab,
});
